import { useMemo } from 'react';
import { encode } from 'uqr';

/**
 * A QR code drawn on the phone itself as a PNG: no outside service, so it shows at the curb with
 * no signal, and a long press saves it like any picture.
 */
export function QrCode({ value, alt, className = '', size = 400 }: { value: string; alt: string; className?: string; size?: number }) {
  const src = useMemo(() => {
    const { data } = encode(value, { ecc: 'M', border: 2 });
    const scale = Math.max(1, Math.floor(size / data.length));
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = data.length * scale;
    const g = canvas.getContext('2d')!;
    g.fillStyle = '#ffffff';
    g.fillRect(0, 0, canvas.width, canvas.height);
    g.fillStyle = '#000000';
    data.forEach((row, y) => row.forEach((dark, x) => dark && g.fillRect(x * scale, y * scale, scale, scale)));
    return canvas.toDataURL('image/png');
  }, [value, size]);
  return <img src={src} alt={alt} className={className} style={{ imageRendering: 'pixelated' }} />;
}
